/* cheeky.js: behaviours for the Cheekynook landing (countdowns, gallery, bundles, cart, sticky bar, feed) */
(function () {
  if (window.__ckInit) return; window.__ckInit = true;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Shopify money format from Liquid (shop.money_format). Integer cents in, string out.
     Never float-multiply currency rates. amount uses toFixed(2) so .99 stays .99. */
  function ckFormatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    if (cents < 0) cents = 0;
    format = format || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] != null && precision > 0 ? decimal + parts[1] : '');
    }
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var m = format.match(placeholder);
    var token = m ? m[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals':
        value = withDelims(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelims(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelims(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelims(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelims(cents, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = withDelims(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelims(cents, 2, ' ', '.');
        break;
      case 'amount':
      default:
        value = withDelims(cents, 2);
        break;
    }
    return format.replace(placeholder, value);
  }

  /* Countdowns: any [data-ck-deadline] containing [data-d],[data-h],[data-m],[data-s] */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    $$('[data-ck-deadline]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-ck-deadline'));
      if (isNaN(end)) return;
      var t = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), m = Math.floor(t % 3600 / 60), s = t % 60;
      var map = { d: d, h: pad(h), m: pad(m), s: pad(s) };
      Object.keys(map).forEach(function (k) { var n = el.querySelector('[data-' + k + ']'); if (n) n.textContent = map[k]; });
      if (t === 0) { var c = el.closest('[data-ck-hide-ended]'); if (c) c.style.display = 'none'; }
    });
  }
  tick(); setInterval(tick, 1000);

  /* Gallery: scroll the images physically; keep thumbnail state in sync with touch. */
  $$('[data-ck-gallery]').forEach(function (g) {
    var track = g.querySelector('.ck-gal__track');
    if (!track) return;
    var imgs = $$('img', track), thumbs = $$('.ck-gal__thumbs button', g), i = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function mark(n) {
      i = Math.max(0, Math.min(n, imgs.length - 1));
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function show(n) {
      if (!imgs.length) return;
      var next = (n + imgs.length) % imgs.length;
      imgs[next].loading = 'eager';
      mark(next);
      track.scrollTo({ left: next * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth' });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = g.querySelector('.ck-gal__arrow--prev'), next = g.querySelector('.ck-gal__arrow--next');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    var frame;
    track.addEventListener('scroll', function () {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
    }, {passive:true});
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); show(i + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    if (window.ResizeObserver) new ResizeObserver(function () {
      track.scrollTo({left: i * track.clientWidth, behavior:'instant'});
    }).observe(track);
    g.ckShowMedia = function (id) { var ids = (g.getAttribute('data-media-ids') || '').split(','), k = ids.indexOf(String(id)); if (k > -1) show(k); };
    mark(0);
  });

  /* Buy box: tiers, gifts, add to cart, sticky bar */
  $$('[data-ck-buy]').forEach(function (box) {
    var tiers = $$('.ck-tier', box), btn = box.querySelector('[data-ck-atc]'), err = box.querySelector('.ck-err');
    var sticky = document.querySelector('[data-ck-sticky]');
    var stickyBtn = sticky && sticky.querySelector('button'), stickyName = sticky && sticky.querySelector('[data-ck-sticky-name]');
    var label = btn ? btn.getAttribute('data-label') : 'Add to cart';
    function current() { var on = box.querySelector('.ck-tier input:checked'); return on ? on.closest('.ck-tier') : tiers[0]; }
    var giftsReady = false;
    /* Prices come only from Liquid (data-total / data-scarf-*). Never multiply by
       Shopify.currency.rate, never re-format cents for display, never rewrite .ck-tier__now. */
    function sync() {
      var t = current(); if (!t) return;
      tiers.forEach(function (x) { x.classList.toggle('is-on', x === t); });
      var digitalOnly = t.getAttribute('data-digital-only') === 'true';
      var q = digitalOnly ? 0 : (parseInt(t.getAttribute('data-qty'), 10) || 1);
      var stylesWrap = box.querySelector('[data-ck-styles]');
      var unlocks = box.querySelectorAll('[data-ck-bundle-unlocks]');
      function setHidden(el, on) {
        if (!el) return;
        el.hidden = !!on;
        el.setAttribute('aria-hidden', on ? 'true' : 'false');
        if (on) el.style.display = 'none';
        else el.style.removeProperty('display');
      }
      setHidden(stylesWrap, digitalOnly);
      unlocks.forEach(function (el) { setHidden(el, digitalOnly); });
      $$('.ck-style', box).forEach(function (row) {
        if (digitalOnly) row.hidden = true;
        else row.hidden = (parseInt(row.getAttribute('data-style-index'), 10) || 1) > q;
      });
      /* ATC total = tier cents + hoodie cents when ticked. Format with shop.money_format. */
      var moneyFormat = box.getAttribute('data-money-format') || '${{amount}}';
      var tierCents = parseInt(t.getAttribute('data-total-cents'), 10) || 0;
      var compareCents = parseInt(t.getAttribute('data-compare-cents'), 10) || 0;
      var hoodieAdd = box.querySelector('[data-ck-hoodie-add]');
      var hoodieSizeSel = box.querySelector('[data-ck-hoodie-size]');
      var hoodieOn = !digitalOnly && hoodieAdd && hoodieAdd.checked && hoodieSizeSel && hoodieSizeSel.value;
      var hoodieCents = 0;
      if (hoodieOn) {
        var hOpt = hoodieSizeSel.options[hoodieSizeSel.selectedIndex];
        hoodieCents = parseInt(hOpt && hOpt.getAttribute('data-price-cents'), 10) || 0;
      }
      var sumCents = tierCents + hoodieCents;
      var total = sumCents ? ckFormatMoney(sumCents, moneyFormat) : (t.getAttribute('data-total') || '');
      var compareTotal = '';
      if (compareCents > tierCents) {
        var compareSum = compareCents + hoodieCents;
        if (compareSum > sumCents) compareTotal = ckFormatMoney(compareSum, moneyFormat);
      }
      if (btn) {
        btn.textContent = total ? (label + ' · ' + total) : label;
        if (compareTotal) btn.setAttribute('data-compare-display', compareTotal);
        else btn.removeAttribute('data-compare-display');
      }
      if (stickyBtn) stickyBtn.textContent = total ? (label + ' · ' + total) : label;
      if (stickyName) stickyName.textContent = t.getAttribute('data-name');
      var priceEl = box.querySelector('[data-ck-price]');
      if (priceEl) {
        var nowEl = priceEl.querySelector('.ck-price__now');
        var wasEl = priceEl.querySelector('.ck-price__was');
        var saveEl = priceEl.querySelector('.ck-price__save');
        if (digitalOnly) {
          if (nowEl) nowEl.textContent = total;
          if (wasEl) wasEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        } else {
          if (nowEl && priceEl.getAttribute('data-scarf-now')) nowEl.textContent = priceEl.getAttribute('data-scarf-now');
          if (wasEl) {
            var scarfWas = priceEl.getAttribute('data-scarf-was') || '';
            if (scarfWas) { wasEl.textContent = scarfWas; wasEl.hidden = false; }
            else wasEl.hidden = true;
          }
          if (saveEl) {
            var scarfSave = priceEl.getAttribute('data-scarf-save') || '';
            if (scarfSave) { saveEl.textContent = scarfSave; saveEl.hidden = false; }
            else saveEl.hidden = true;
          }
        }
      }
      $$('.ck-gift', box).forEach(function (gf) {
        var need = parseInt(gf.getAttribute('data-unlock'), 10) || 1, on = !digitalOnly && q >= need;
        var wasOn = gf.classList.contains('is-on');
        gf.classList.toggle('is-on', on);
        if (!on) {
          clearTimeout(gf.ckGiftTimer);
          gf.classList.remove('is-opening');
        } else if (giftsReady && !wasOn) {
          gf.classList.add('is-opening');
          gf.ckGiftTimer = setTimeout(function () { gf.classList.remove('is-opening'); }, 950);
        }
      });
      giftsReady = true;
      var hoodieBox = box.querySelector('[data-ck-hoodie]');
      if (hoodieBox) {
        hoodieBox.hidden = !!digitalOnly;
        if (digitalOnly) {
          var hAdd = hoodieBox.querySelector('[data-ck-hoodie-add]');
          if (hAdd) hAdd.checked = false;
        }
      }
    }
    tiers.forEach(function (t) { var r = t.querySelector('input'); if (r) r.addEventListener('change', sync); });
    $$('[data-ck-style]', box).forEach(function (sel) {
      function pic() { var o = sel.options[sel.selectedIndex], im = sel.closest('.ck-style').querySelector('[data-ck-style-img]'); if (o && im && o.getAttribute('data-img')) im.src = o.getAttribute('data-img'); }
      sel.addEventListener('change', function () { pic(); var o = sel.options[sel.selectedIndex], gal = document.querySelector('[data-ck-gallery]'); if (o && gal && gal.ckShowMedia && o.getAttribute('data-media')) gal.ckShowMedia(o.getAttribute('data-media')); }); pic();
    });
    var hoodieSize = box.querySelector('[data-ck-hoodie-size]');
    var hoodiePrice = box.querySelector('[data-ck-hoodie-price]');
    if (hoodieSize && hoodiePrice) {
      hoodieSize.addEventListener('change', function () {
        var o = hoodieSize.options[hoodieSize.selectedIndex];
        if (o) {
          if (o.getAttribute('data-price')) hoodiePrice.textContent = o.getAttribute('data-price');
          if (o.getAttribute('data-price-cents')) hoodiePrice.setAttribute('data-price-cents', o.getAttribute('data-price-cents'));
        }
        sync();
      });
    }
    var hoodieAddInit = box.querySelector('[data-ck-hoodie-add]');
    var hoodieCard = box.querySelector('.ck-hoodie__card');
    if (hoodieAddInit && hoodieCard) {
      function syncHoodieOn() {
        hoodieCard.classList.toggle('is-on', !!hoodieAddInit.checked);
        sync();
      }
      hoodieAddInit.addEventListener('change', syncHoodieOn);
    }
    sync();

    function add() {
      var t = current(), id = t.getAttribute('data-tier-variant') || box.getAttribute('data-variant');
      if (!id) { if (err) { err.textContent = 'This product is not available on the Online Store yet.'; err.style.display = 'block'; } return; }
      var digitalOnly = t.getAttribute('data-digital-only') === 'true';
      var q = digitalOnly ? 0 : (parseInt(t.getAttribute('data-qty'), 10) || 1);
      var sels = $$('[data-ck-style]', box);
      var item = { id: Number(id), quantity: parseInt(t.getAttribute('data-cart-quantity'), 10) || 1 };
      if (digitalOnly) {
        /* Pattern only: add the digital variant alone, no scarf colours or bundle gifts. */
        var items = [item];
      } else {
      var giftProps = {};
      if (q >= 1) giftProps['Gift: Free shipping'] = 'Yes';
      if (q === 2) giftProps['Gift: Free styling guide PDF'] = 'Yes';
      if (q >= 3) {
        giftProps['Gift: Free crochet pattern PDF'] = 'Yes';
      }
      if (Object.keys(giftProps).length) giftProps['_gift'] = 'bundle';
      if (sels.length) {
        if (t.getAttribute('data-main') === 'true') {
          item.id = Number(sels[0].value); item.quantity = q;
          item.properties = giftProps;
        } else {
          var propLabel = box.getAttribute('data-style-prop') || 'Item', props = Object.assign({}, giftProps);
          sels.slice(0, q).forEach(function (sel, k) { var o = sel.options[sel.selectedIndex]; props[propLabel + ' ' + (k + 1)] = o ? o.getAttribute('data-title') : ''; });
          item.properties = props;
        }
      } else if (Object.keys(giftProps).length) {
        item.properties = giftProps;
      }
      /* Extras live in the cart drawer now; product page only adds the toy. */
      var items = [item];
      }
      if (!digitalOnly) {
        var hoodieAdd = box.querySelector('[data-ck-hoodie-add]');
        var hoodieSizeSel = box.querySelector('[data-ck-hoodie-size]');
        if (hoodieAdd && hoodieAdd.checked && hoodieSizeSel && hoodieSizeSel.value) {
          items.push({ id: Number(hoodieSizeSel.value), quantity: 1, properties: { '_ck_upsell': 'hoodie' } });
        }
      }
      [btn, stickyBtn].forEach(function (b) { if (b) { b.disabled = true; b.textContent = 'Adding…'; } });
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); }); return r.json(); })
        .then(function () {
          if (window.FetchyDrawer) { return window.FetchyDrawer.afterAdd().then(function () { [btn, stickyBtn].forEach(function (b) { if (b) b.disabled = false; }); sync(); }); }
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        })
        .catch(function (e) {
          if (err) { err.textContent = e.message; err.style.display = 'block'; }
          [btn, stickyBtn].forEach(function (b) { if (b) b.disabled = false; }); sync();
        });
    }
    if (btn) btn.addEventListener('click', add);
    if (stickyBtn) stickyBtn.addEventListener('click', add);
    var change = sticky && sticky.querySelector('[data-ck-change]');
    if (change) change.addEventListener('click', function (e) { e.preventDefault(); box.scrollIntoView({ behavior: 'smooth', block: 'start' }); });

    if (sticky && btn) {
      var ticking = false;
      function upd() { ticking = false; var r = btn.getBoundingClientRect(); sticky.classList.toggle('is-on', r.bottom < 0); }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd); upd();
    }
  });

  /* Feed carousel arrows */
  $$('[data-ck-feed]').forEach(function (f) {
    var tr = f.querySelector('.ck-feed__track'), p = f.querySelector('.ck-feed__prev'), n = f.querySelector('.ck-feed__next');
    function step(dir) { var c = tr.querySelector('.ck-feed__card'); tr.scrollBy({ left: dir * ((c ? c.offsetWidth : 260) + 16), behavior: 'smooth' }); }
    function upd() { if (p) p.disabled = tr.scrollLeft < 4; if (n) n.disabled = tr.scrollLeft + tr.clientWidth > tr.scrollWidth - 4; }
    if (p) p.addEventListener('click', function () { step(-1); });
    if (n) n.addEventListener('click', function () { step(1); });
    tr.addEventListener('scroll', upd, { passive: true }); upd();
  });

  /* Showcase video: load only when visible */
  $$('video[data-ck-lazy]').forEach(function (v) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { $$('source[data-src]', v).forEach(function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); }); v.load(); v.play().catch(function () {}); io.disconnect(); }
      });
    }, { rootMargin: '200px' });
    io.observe(v);
  });


})();
